import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import HomeworkModal from '../modals/HomeworkModal';
import IssueModal from '../modals/IssueModal';
import { Card, CardMobile } from '../commonUtils';
import { createConversation } from '../../../../../store/actions/conversations';

function Completed(props) {

    let { width, arr } = props;
    if (!Array.isArray(arr)) arr = [];

    const [issueModal, setIssueModal] = React.useState(false);
    const [homeworkModal, setHomeworkModal] = React.useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleMessageStudent = async (session) => {
        const userProfile = JSON.parse(localStorage.getItem("profile"));
        if (!userProfile?._id || !session?.studentId) {
            console.error("Missing user or student ID");
            return;
        }

        try {
            const res = await dispatch(createConversation({
                senderId: userProfile._id,
                receiverId: session.studentId._id || session.studentId
            }));

            if (res) {
                navigate("/teacher/messages", {
                    state: { cchat: res.status ? res : (res.conv?.[0] || res) }
                });
            }
        } catch (err) {
            console.error("Error creating conversation:", err);
        }
    };

    const createDropDownArr = (session) => [
        {
            text: 'Message Student',
            modal: () => handleMessageStudent(session)
        },
        {
            text: 'Resolve Issue',
            modal: setIssueModal
        },
        {
            text: 'Assign Homework',
            modal: setHomeworkModal
        }
    ];

    arr = arr?.filter((item) => item.status === "Completed")


    return (
        <>
            {/* Issue Modal */}
            {issueModal ?
                <IssueModal setIssueModal={setIssueModal} width={width} />
                :
                <></>
            }

            {/* Homework Modal */}
            {homeworkModal ?
                <HomeworkModal setHomeworkModal={setHomeworkModal} width={width} />
                :
                <></>
            }

            {width >= 992 ?
                <div style={{ marginTop: '50px' }}>
                    {arr && arr.length > 0 ? (
                        arr.map((item, index) => (
                            <Card
                                key={index}
                                width={width}
                                cardInfo={item}
                                dropDown={createDropDownArr(item)}
                            />
                        )))
                        :
                        <div style={{ textAlign: 'center' }}>No Completed Sessions</div>
                    }
                </div>
                :
                <div style={{ marginTop: '30px' }}>
                    {arr && arr.length > 0 ? (
                        arr.map((item, index) => (
                            <CardMobile
                                key={index}
                                width={width}
                                cardInfo={item}
                                dropDown={createDropDownArr(item)}
                            />
                        )))
                        :
                        <div style={{ textAlign: 'center' }}>No Completed Sessions</div>
                    }
                </div>
            }
        </>
    )
}

export default Completed;